import { createContext, useReducer, useEffect } from "react"

export const UserContext = createContext()

export function userReducer(state, action) {
    switch(action.type) {
        case "LOGIN" :
            return {
                userData: action.payload
            }
        case "ADD_TO_WISHLIST" :
            return {
                userData: {
                    ...state.userData,
                    user: {
                        ...state.userData.user,
                        wishlist: [ ...state.userData.user.wishlist, action.payload ]
                    },
                    notification: {
                        ...state.userData.notification,
                        type: action.type,
                        productName: action.payload.title,
                        productImage: action.payload.image
                    }
                },
                
            }
        case "REMOVE_FROM_WISHLIST" :
            return {
                userData: {
                    ...state.userData,
                    user: {
                        ...state.userData.user,
                        wishlist: state.userData.user.wishlist.filter(e => e._id !== action.payload)
                    }
                }
            }
        case "ADD_TO_CART" :
            return {
                userData: {
                    ...state.userData,
                    user: {
                        ...state.userData.user,
                        cart: [ ...state.userData.user.cart, action.payload ]
                    },
                    notification: {
                        ...state.userData.notification,
                        type: action.type,
                        productName: action.payload.title,
                        productImage: action.payload.image
                    }
                }
            }
        case "UPDATE_CART_ITEM" :
            return {
                userData: {
                    ...state.userData,
                    user: {
                        ...state.userData.user,
                        cart: [
                            ...action.payload.filteredCart, {
                                ...action.payload.existingItem,
                                quantity: action.payload.updatedQuantity
                            }
                        ]
                    },
                    notification: {
                        ...state.userData.notification,
                        type: action.type,
                        productName: action.payload.existingItem.title,
                        productImage: action.payload.existingItem.image,
                        updatedQuantity: action.payload.updatedQuantity
                    }
                }
            }
        case "UPDATE_CART" :
            return {
                userData: {
                    ...state.userData,
                    user: {
                        ...state.userData.user,
                        cart: action.payload.updatedCart
                    },
                    notification: {
                        ...state.userData.notification,
                        type: action.type,
                        items: action.payload.updatedCart.length,
                        subtotal: action.payload.subtotal
                    }
                }
            }
        case "REMOVE_FROM_CART" :
            return {
                userData: {
                    ...state.userData,
                    user: {
                        ...state.userData.user,
                        cart: state.userData.user.cart.filter(e => e.id !== action.payload)
                    }
                }
            }
        case "UPDATE_PROFILE" :
            return {
                userData: {
                    ...state.userData,
                    user: {
                        ...state.userData.user,
                        ...action.payload
                    },
                    notification: { type: action.type }
                }
            }
        case "PLACE_ORDER" :
            return {
                userData: {
                    ...state.userData,
                    user: {
                        ...state.userData.user,
                        orders: [ ...state.userData.user.orders, action.payload ]
                    },
                    notification: { type: action.type }
                }
            }
        case "UPDATE_ORDER" :
            return {
                userData: {
                    ...state.userData,
                    user: {
                        ...state.userData.user,
                        orders: state.userData.user.orders.map(e => {
                            if(e._id === action.payload._id) {
                                return { ...e, status: action.payload.status }
                            } else {
                                return e
                            }
                        })
                    },
                    notification: { type: action.type }
                }
            }
        case "UPDATE_ORDER_ERROR_ACTION_FORBIDDEN" :
            return {
                userData: {
                    ...state.userData,
                    notification: { type: action.type }
                }
            }
        case "LOGOUT" :
            return {
                userData: null
            }
        default :
            return state
    }
}

export function UserContextProvider({ children }) {
    const [state, dispatch] = useReducer(userReducer, { userData: null })

    useEffect(() => {
        const userData = JSON.parse(localStorage.getItem("user"))

        if(userData) {
            dispatch({ type: "LOGIN", payload: userData })
        }
    }, [])

    return (
        <UserContext.Provider value={{ ...state.userData, dispatch }}>
            {children}
        </UserContext.Provider>
    )
}